// user living Situation
export enum LIVING_SITUATION {
  RENTING = 'renting',
  RENTING_OWN_ANOTHER_PROPERTY = 'rentingButOwnAnotherProperty',
  OWNER_WITH_MORTGAGE = 'ownerWithMortgage',
  OWNER_WITHOUT_MORTGAGE = 'ownerWithoutMortgage',
  LIVING_WITH_PARENTS = 'livingWithParents',
  BOARD = 'board',
  COUNCIL_TENANT = 'councilTenant',
}
export const livingSituationOptions = Object.values(LIVING_SITUATION)
export type LivingSituation = (typeof livingSituationOptions)[number]
export const livingSituationMap = {
  [LIVING_SITUATION.RENTING]: 'Renting',
  [LIVING_SITUATION.RENTING_OWN_ANOTHER_PROPERTY]: 'Renting But Own Property',
  [LIVING_SITUATION.OWNER_WITH_MORTGAGE]: 'Owner With Mortgage',
  [LIVING_SITUATION.OWNER_WITHOUT_MORTGAGE]: 'Owner Without Mortgage',
  [LIVING_SITUATION.LIVING_WITH_PARENTS]: 'Living With Parents',
  [LIVING_SITUATION.BOARD]: 'Board',
  [LIVING_SITUATION.COUNCIL_TENANT]: 'Council Tenant',
}

// refactored user living Situation
export enum REF_LIVING_SITUATION {
  RENTING = 1,
  RENTING_OWN_ANOTHER_PROPERTY = 2,
  OWNER_WITH_MORTGAGE = 3,
  OWNER_WITHOUT_MORTGAGE = 4,
  LIVING_WITH_PARENTS = 5,
  BOARD = 6,
  COUNCIL_TENANT = 7,
}
export const refLivingSituationOptions = Object.values(REF_LIVING_SITUATION)
export type RefLivingSituation = (typeof refLivingSituationOptions)[number]
export const refLivingSituationMap = {
  [REF_LIVING_SITUATION.RENTING]: 'Renting',
  [REF_LIVING_SITUATION.RENTING_OWN_ANOTHER_PROPERTY]: 'Renting But Own Property',
  [REF_LIVING_SITUATION.OWNER_WITH_MORTGAGE]: 'Owner With Mortgage',
  [REF_LIVING_SITUATION.OWNER_WITHOUT_MORTGAGE]: 'Owner Without Mortgage',
  [REF_LIVING_SITUATION.LIVING_WITH_PARENTS]: 'Living With Parents',
  [REF_LIVING_SITUATION.BOARD]: 'Board',
  [REF_LIVING_SITUATION.COUNCIL_TENANT]: 'Council Tenant',
}
